const DISCWORLD_TRACKER_COOKIE_NAME = "discworldTracker"

export { DISCWORLD_TRACKER_COOKIE_NAME }
